import { isEnteredStockTakeLine } from './stockTakeBelowParSoFar'
import { summarizeStockTakeProductProgress } from './stockTakePreferredPack'

export const currentStockTakeUserName = (account = {}) =>
  String(
    account?.name || account?.fullName || account?.emailAddress || '',
  ).trim()

export const countCountedStockTakeLines = (lines = []) =>
  (Array.isArray(lines) ? lines : []).filter(isEnteredStockTakeLine).length

export const STOCK_TAKE_ASK_OLLIE_QUIET_LABEL = 'Ask Ollie'

export const hasSavedCountedStockTakeLine = (savedLines = []) =>
  countCountedStockTakeLines(savedLines) > 0

export const formatStockTakeCountProgress = (lines = [], { total } = {}) => {
  const progress = summarizeStockTakeProductProgress(lines)
  const totalItems = total == null ? progress.total : Number(total) || 0
  const counted = progress.counted
  const percent =
    totalItems > 0 ? Math.min(100, Math.round((counted / totalItems) * 100)) : 0
  const noun = totalItems === 1 ? 'product' : 'products'
  return {
    counted,
    total: totalItems,
    percent,
    extraPackRows: progress.extraPackRows,
    text: `${counted} / ${totalItems} ${noun} counted (${percent}%)`,
  }
}

export const displayStockTakeLastEditedBy = ({
  stockTake,
  currentUserName,
  savedThisVisit,
} = {}) => {
  const you = String(currentUserName || '').trim()
  if (savedThisVisit && you) return you
  return (
    stockTake?.updatedByName ||
    stockTake?.updatedBy?.name ||
    stockTake?.updatedBy?.fullName ||
    stockTake?.updatedBy?.email ||
    stockTake?.lastEditedBy ||
    you ||
    'Not available'
  )
}

const latestTimestamp = values => {
  const times = (Array.isArray(values) ? values : [])
    .map(value => Date.parse(value))
    .filter(Number.isFinite)
  if (!times.length) return null
  return new Date(Math.max(...times)).toISOString()
}

export const stockTakeSavedAtFromRecord = (stockTake, savedLines = []) => {
  const lineTimes = (Array.isArray(savedLines) ? savedLines : []).flatMap(
    line => [line?.updatedAt, line?.lastSavedAt],
  )
  return latestTimestamp([
    stockTake?.updatedAt,
    stockTake?.lastSavedAt,
    ...lineTimes,
  ])
}

export const stockTakeHasPersistedCount = (stockTake, savedLines = []) =>
  Boolean(stockTakeSavedAtFromRecord(stockTake, savedLines)) ||
  hasSavedCountedStockTakeLine(savedLines)
